import * as React from 'react';
const NestedListContext = /*#__PURE__*/React.createContext(false);
if (process.env.NODE_ENV !== 'production') {
  NestedListContext.displayName = 'NestedListContext';
}
export default NestedListContext;